import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { TEAM } from "../data/content";

export const Team = () => {
  const { t } = useLang();
  return (
    <section id="team" className="relative py-24 lg:py-32" data-testid="team-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs tracking-[0.2em] uppercase font-mono text-cyan mb-4">{t("team_eyebrow")}</div>
          <h2 className="font-head font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">{t("team_title")}</h2>
          <p className="mt-5 text-base text-zinc-400 leading-relaxed">{t("team_subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {TEAM.map((m, i) => (
            <motion.div
              key={m.key}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative rounded-2xl overflow-hidden border border-white/10 aspect-[3/4] card-glow"
              data-testid={`team-card-${i}`}
            >
              <img src={m.img} alt={m.name} className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#030305] via-transparent to-transparent" />
              <div className="absolute bottom-0 p-5">
                <div className="font-head font-semibold text-white">{m.name}</div>
                <div className="text-xs font-mono text-cyan mt-1">{m.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
